import SearchMultiSelect from './SearchMultiSelect'

export default SearchMultiSelect
